import * as types from "../types";
import { requestAuth } from "../../helpers/FetchApi";
import appSettings from "../../AppSettings";
import { ActionsCreators } from "../../actions";
import { toast } from "react-toastify";
import strings from "../../helpers/Localization";

export const actionCreators = {
    GetCompositionsList: (pageNumber, pageSize, sortExpression, filterExpression, tagSearchRequest, PaginationType, onSuccess, secondary) => async (dispatch, store) => {
        secondary ? dispatch({ type: types.GET_COMPOSITIONS_SECONDARY_COMPLETED, payload: null }) : dispatch({ type: types.GET_COMPOSITIONS_COMPLETED, payload: null });
        if (pageSize < 0) {return onSuccess(null);}
        await requestAuth(appSettings.SKALINKAPIURL + "/api/Composition/OrganizationCompositions/" + store().currentuser.currentorganization.id + "?"
        + "pageNumber=" + pageNumber
        + "&pageSize=" + pageSize
        + (sortExpression ? "&sortExpression=" + sortExpression : "")
        + (filterExpression ? "&filterExpression=" + filterExpression : "")
        + (tagSearchRequest ? tagSearchRequest : "")
        , {
            method: "GET"
        }).then((data) => {
            data.sortExpression = sortExpression;
            data.filterExpression = filterExpression;
            data.tagSearchRequest = tagSearchRequest;
            data.PaginationType = PaginationType;
            secondary ? dispatch({ type: types.GET_COMPOSITIONS_SECONDARY_COMPLETED, payload: data }) : dispatch({ type: types.GET_COMPOSITIONS_COMPLETED, payload: data });
            return onSuccess(data);
        }).catch( (data) => {
            console.log(data);
        });
    },

    GetSecondaryCompositionsList: (pageNumber, pageSize, sortExpression, filterExpression, tagSearchRequest, PaginationType, onSuccess) => (dispatch) => {
        dispatch(ActionsCreators.GetCompositionsList(pageNumber, pageSize, sortExpression, filterExpression, tagSearchRequest, PaginationType, onSuccess, true));
    },

    GetComposition: (id, onSuccess) => async (dispatch, store) => {

        await requestAuth(appSettings.SKALINKAPIURL + "/api/Composition/" + id, {
            method: "GET"
        }).then((data) => {
            return onSuccess({
                composition: data,
                userAccessLevel: data.userAccessLevel
            });
        }).catch( (data) => {
            console.log(data);
        });
    },

    DeleteComposition: (Id, onSuccess) => async (dispatch, store) => {

        await requestAuth(appSettings.SKALINKAPIURL + "/api/Composition/" + Id, {
            method: "DELETE"
        }).then((data) => {
            toast.success(strings.compDeleted);
            return onSuccess();
        }).catch( (data) => {
            console.log("error", data);
        });
    },

    EditComposition: (comp, onSuccess, onError) => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/Composition/" + store().currentuser.currentorganization.id, {
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(comp),
            method: "PUT"
        }).then((data) => {
            onSuccess(data);
        }).catch( (data) => {
            if (onError) {onError();}
            console.log("error", data);
        });

    },

    CreateComposition: (object, onSuccess, onError) => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/Composition/" + store().currentuser.currentorganization.id, {
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(object),
            method: "POST"
        }).then((data) => {
            onSuccess(data);
        }).catch( (data) => {
            if (onError) {onError();}
            console.log("error", data);
        });
    },

    DuplicateComposition: (id, name, onSuccess) => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/Composition/Duplicate/" + id + (name ? "?name=" + name : ""), {
            method: "GET"
        }).then((data) => {
            toast.success(strings.compDuplicated);
            return onSuccess(data);
        }).catch( (data) => {
            console.log(data);
        });
    },

    GetLibrariesParameters: (compositionId, onSuccess) => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/LibraryParameters/" + compositionId, {
            method: "GET"
        }).then((data) => {
            return onSuccess(data);
        }).catch( (data) => {
            console.log(data);
        });
    }

};
